export const POSITION_FIXED = {
  NONE: 0,
  FIRST: 1,
  LAST: 2,
  ALL: 3
};
